import { getCdnEndpoint, getMcpEndpoint, getProjectEndpoint } from 'app/branches/endpoints';

export type UsefulSnippitsOwnProps = {
  readonly projectId: string;
  readonly branch: string;
  readonly branchPath: string;
  readonly onCopy?: () => void;
};

export const useUsefulSnippits = (props: UsefulSnippitsOwnProps) => {
  const { projectId, branch, onCopy } = props;
  const apiEndpoint = getProjectEndpoint(projectId, branch);
  const mcpEndpoint = getMcpEndpoint(projectId);
  const cdnEndpoint = getCdnEndpoint(projectId, branch);

  return { ...props, apiEndpoint, mcpEndpoint, cdnEndpoint, onCopy };
};

export type UsefulSnippitsProps = ReturnType<typeof useUsefulSnippits>;
